var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -679) translate(105 119) translate(24 552) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -679) translate(105 119) translate(24 552) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.667 8.889c2.209 0 4 1.79 4 4v6.222c0 2.21-1.791 4-4 4H9.333c-2.209 0-4-1.79-4-4V12.89c0-2.21 1.791-4 4-4h13.334zm-10.63 2.444c-1.861 0-3.37 1.51-3.37 3.37 0 1.862 1.509 3.371 3.37 3.371.835 0 1.602-.306 2.193-.814l.14.145v.41l2.857 2.852.773-.773-2.852-2.857h-.41l-.145-.14c.508-.591.814-1.358.814-2.193 0-1.862-1.508-3.37-3.37-3.37zm0 1.037c1.291 0 2.333 1.043 2.333 2.334 0 1.29-1.042 2.333-2.333 2.333-1.291 0-2.333-1.042-2.333-2.333 0-1.291 1.042-2.334 2.333-2.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M19.556 14.222L24.889 14.222 22.222 17.778z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDropdown);
export default __webpack_public_path__ + "static/media/selectDropdown.686d1a54c9b26faa990366ec564d1632.svg";
export { ForwardRef as ReactComponent };